const servicosRoutes = [
  {
    path: '/servicos/dashboard',
    name: 'servicos.dashboard',
    component: () => import('../views/servicos/Dashboard.vue'),
  },
  {
    path: '/servicos/control-tower',
    name: 'servicos.controlTower',
    component: () => import('../views/servicos/ControlTower.vue'),
  },
  {
    path: '/servicos/ordem-servico',
    name: 'servicos.ordemServico',
    component: () => import('../views/servicos/OrdemServico.vue'),
  },
  {
    path: '/servicos/dashboard-rentabilidade',
    name: 'servicos.dashboardRentabilidade',
    component: () => import('../views/servicos/DashboardRentabilidade.vue'),
  },
  {
    path: '/servicos/consignado',
    name: 'servicos.consignado',
    component: () => import('../views/servicos/Consignado.vue'),
  },
  {
    path: '/servicos/proposta-locacao/:recnum?',
    name: 'servicos.propostaLocacao',
    component: () => import('../views/servicos/PropostaLocacao.vue'),
  },
  {
    path: '/servicos/textos-legais',
    name: 'servicos.textosLegais',
    component: () => import('../views/servicos/TextosLegais.vue'),
  },
  {
    path: '/servicos/tipos-proposta',
    name: 'servicos.tiposProposta',
    component: () => import('../views/servicos/TiposProposta.vue'),
  },
  {
    path: '/servicos/farol-equipamentos',
    name: 'servicos.farolEquipamentos',
    component: () => import('../views/servicos/FarolEquipamentos.vue'),
  },
  {
    path: '/servicos/consulta-equipamentos',
    name: 'servicos.consultaEquipamentos',
    component: () => import('../views/servicos/ConsultaEquipamentos.vue'),
  },
  {
    path: '/servicos/relatorio-checagem',
    name: 'servicos.relatorioChecagem',
    component: () => import('../views/servicos/RelatorioChecagem.vue'),
  },
  {
    path: '/servicos/tabela-preco-periodo',
    name: 'servicos.tabela-preco-periodo',
    component: () => import('../views/servicos/TabelaPrecoPeriodo.vue'),
  },
  {
    path: '/servicos/tabela-preco',
    name: 'servicos.tabela-preco',
    component: () => import('../views/servicos/TabelaPreco.vue'),
  },
  {
    path: '/servicos/consulta-locacao-rapida',
    name: 'servicos.consulta-locacao-rapida',
    component: () => import('../views/servicos/ConsultaLocacaoRapida.vue'),
  },
  {
    path: '/servicos/contrato-digital',
    name: 'contratos.contratoDigital',
    component: () => import('../views/servicos/ContratoDigital.vue'),
  },
  {
    path: '/servicos/representante-filial',
    name: 'contratos.representante-filial',
    component: () => import('../views/servicos/RepresentanteFilial.vue'),
  },
  {
    path: '/servicos/consulta-contrato-digital',
    name: 'servicos.consulta-contrato-digital',
    component: () => import('../views/servicos/ConsultaContratoDigital.vue'),
  },
  {
    path: '/servicos/consulta-reajuste',
    name: 'servicos.consulta-reajuste',
    component: () => import('../views/servicos/ConsultaReajuste.vue'),
  },
  {
    path: '/servicos/config-nfse',
    name: 'servicos.paramfi',
    component: () => import('../views/servicos/Paramfi.vue'),
  },
  {
    path: '/servicos/modelo-impressao',
    name: 'servicos.modeloImpressao',
    component: () => import('../views/servicos/ModeloProposta.vue'),
  },
  {
    path: '/servicos/consulta-proposta',
    name: 'servicos.consulta-proposta',
    component: () => import('../views/servicos/ConsultaProposta.vue'),
  },
  {
    path: '/servicos/consulta-equipamentos-locados',
    name: 'servicos.consulta-equipamentos-locados',
    component: () => import('../views/servicos/ConsultaEquipamentosLocados.vue'),
  },
  {
    path: '/servicos/rota-entrega',
    name: 'servicos.rota-entrega',
    component: () => import('../views/servicos/RotaEntrega.vue'),
  },
  {
    path: '/servicos/consumo-contrato',
    name: 'servicos.consumo-contrato',
    component: () => import('../views/servicos/ConsumoContrato.vue'),
  },
  {
    path: '/servicos/fluxograma-equipamentos',
    name: 'servicos.fluxograma-equipamentos',
    component: () => import('../views/servicos/FluxogramaEquipamentos.vue'),
  },
  {
    path: '/servicos/consulta-equipamentos-locados-manutencao',
    name: 'servicos.consultaEquipamentosLocadosManutencao',
    component: () => import('../views/servicos/ConsultaEquipamentosLocadosManutencao.vue'),
  },
  {
    path: '/servicos/consulta-entregas',
    name: 'servicos.consulta-entregas',
    component: () => import('../views/servicos/ConsultaEntregas.vue'),
  },
  {
    path: '/servicos/consulta-equipamentos-os',
    name: 'servicos.consulta-equipamentos-os',
    component: () => import('../views/servicos/ConsultaEquipamentosOS.vue'),
  },
  {
    path: '/servicos/mnemonicos',
    name: 'servicos.mnemonicos',
    component: () => import('../views/servicos/MnemonicosContrato.vue'),
  },
  {
    path: '/servicos/apontamento-bordero-api',
    name: 'servicos.apontamento-bordero-api',
    component: () => import('../views/servicos/ApontamentoBorderoApi.vue'),
  },
  {
    path: '/servicos/pdl/:recnum?',
    name: 'servicos.pdl',
    component: () => import('../views/servicos/Pdl.vue'),
  },
  {
    path: '/servicos/mensagens',
    name: 'servicos.mensagens',
    component: () => import('../views/servicos/Mensagens.vue'),
  },
  {
    path: '/servicos/pdl-tipo',
    name: 'servicos.pdl.tipo',
    component: () => import('../views/servicos/TiposProposta.vue'),
  },
  {
    path: '/servicos/pdl-consulta',
    name: 'servicos.pdl.consulta',
    component: () => import('../views/servicos/ConsultaPdl.vue'),
  },
  {
    path: '/servicos/pdl-movimentos-caixa',
    name: 'servicos.pdl.movimentos.caixa',
    component: () => import('../views/servicos/PdlMovimentosCaixa.vue'),
  },
  {
    path: '/servicos/os-manutencao',
    name: 'servicos.os.manutencao',
    component: () => import('../views/servicos/OsManutencao.vue'),
  },
  {
    path: '/servicos/modelo-preventiva',
    name: 'servicos.modelo.preventiva',
    component: () => import('../views/servicos/ModeloPreventiva.vue'),
  },
  {
    path: '/servicos/monitor-preventiva',
    name: 'servicos.monitor.preventiva',
    component: () => import('../views/servicos/MonitorPreventiva.vue'),
  },
  {
    path: '/servicos/consulta-mensagens-whatsapp',
    name: 'servicos.consulta-mensagens-whatsapp',
    component: () => import('../views/servicos/ConsultaMensagensWhatsapp.vue'),
  },
  {
    path: '/servicos/situacao-dos-contratos',
    name: 'servicos.situacao.dos.contratos',
    component: () => import('../views/servicos/SituacaoDosContratos.vue'),
  },
  {
    path: '/servicos/historico-reajuste',
    name: 'servicos.historico.reajuste',
    component: () => import('../views/servicos/HistoricoReajuste.vue'),
  },
  {
    path: '/servicos/whatsapp',
    name: 'servicos.whatsapp',
    component: () => import('../views/servicos/Whatsapp.vue'),
  },
  {
    path: '/servicos/mnemonicosSitContratos',
    name: 'servicos.whatsapp',
    component: () => import('../views/servicos/mnemonicosSitContratos.vue'),
  },
  {
    path: '/servicos/mnemonicos-proposta',
    name: 'servicos.mnemonicos-proposta',
    component: () => import('../views/servicos/MnemonicosProposta.vue'),
  },
  {
    path: '/servicos/consulta-reajuste-contratos',
    name: 'servicos.consulta-reajuste-contratos',
    component: () => import('../views/servicos/ConsultaReajusteContratos.vue'),
  },
  {
    path: '/servicos/crteletronico/:oservico?',
    name: 'servicos.crteletronico',
    component: () => import('../views/servicos/CrtEletronico.vue'),
  },
  {
    path: '/servicos/campos-extras-movimentacao',
    name: 'servicos.campos-extras-movimentacao',
    component: () => import('../views/servicos/CamposExtrasMovimentacao.vue'),
  },
  {
    path: '/servicos/campos-extras-movimentacao-dados',
    name: 'servicos.campos-extras-movimentacao-dados',
    component: () => import('../views/servicos/CamposExtrasMovimentacaoDados.vue'),
  },
];

export default servicosRoutes;
